import {createStore, applyMiddleware, compose} from 'redux';
import rootReducer from './rootReducer';
import {browserHistory} from 'react-router';
import {routerMiddleware} from 'react-router-redux';
import createSagaMiddleware, {END} from 'redux-saga';
import thunkMiddleware from 'redux-thunk';
import apiMiddleWare from 'middleware/api';
import transformMiddleWare from 'middleware/transform';

import storeInitialState from './storeInitialState';

export default function (initialState) {
    const sagaMiddleware = createSagaMiddleware();

    const store = createStore(rootReducer, initialState,
        compose(
            applyMiddleware(
                routerMiddleware(browserHistory),
                thunkMiddleware,
                sagaMiddleware,
                apiMiddleWare,
                transformMiddleWare),
            storeInitialState()));

    store.runSaga = sagaMiddleware.run;
    store.close = () => store.dispatch(END);

    return store;
}



// WEBPACK FOOTER //
// ./js/sport-betting/Store.prod.js